<template>
  <main
    class="min-h-screen bg-slate-800 px-4 py-16 text-white md:px-6 lg:px-20"
  >
    <section class="mx-auto max-w-7xl">
      <p
        class="text-sm font-semibold uppercase tracking-[0.25em] text-rtcblue-300"
      >
        {{ $t("solutions.eyebrow") }}
      </p>

      <h1
        class="mt-3 max-w-4xl text-4xl font-extrabold tracking-tight md:text-5xl"
      >
        {{ $t("solutions.title") }}
      </h1>

      <p class="mt-6 max-w-3xl text-lg leading-8 text-slate-300">
        {{ $t("solutions.intro") }}
      </p>
      <p class="mt-2 text-sm leading-4 text-slate-400">
        {{ $t("solutions.hint") }}
      </p>

      <section class="mt-10 grid gap-1">
        <div
          v-for="(solution, i) in $t('solutions.items')"
          :key="i"
          :class="[
            'rounded-3xl border p-6 transition md:p-8 lg:grid lg:grid-cols-5 lg:items-center lg:gap-10',
            meta[i].highlight
              ? 'border-rtcblue-400/30 bg-rtcblue-500/10 hover:border-rtcblue-400/70'
              : 'border-white/10 bg-white/10 hover:border-rtcblue-400/50',
          ]"
        >
          <div class="lg:col-span-2">
            <p
              class="text-sm font-bold uppercase tracking-wider text-rtcblue-300"
            >
              {{ solution.label }}
            </p>

            <div class="mt-3 flex flex-wrap items-center gap-3">
              <h2 class="text-3xl font-bold">
                {{ solution.title }}
              </h2>
              <span
                v-if="meta[i].isNew"
                class="animate-pulse rounded-full bg-gradient-to-r from-pink-500 via-red-500 to-orange-400 px-4 py-1 text-xs font-black uppercase tracking-widest text-white shadow-lg"
              >
                {{ $t("solutions.new") }}
              </span>
            </div>
            <p class="mt-6 leading-8 text-slate-300">
              {{ solution.description }}
            </p>
          </div>
          <div
            class="mt-8 overflow-hidden rounded-[2rem] border border-white/10 lg:col-span-3 lg:mt-0"
          >
            <a
              :href="meta[i].image"
              target="_blank"
              rel="noopener noreferrer"
              class="block"
            >
              <img
                :src="meta[i].image"
                :alt="solution.title"
                class="h-[340px] w-full object-cover transition duration-300 hover:scale-[1.02]"
              />
            </a>
          </div>
        </div>
      </section>
    </section>
  </main>
</template>

<script>
export default {
  name: "SolutionsView",

  data() {
    return {
      meta: [
        { image: "/assets/solutions/water_network_2.png" },
        { image: "/assets/solutions/dynamic_sewer_control.png" },
        { image: "/assets/solutions/operational_monitoring.png" },
        { image: "/assets/solutions/assessment_tools.png" },
        {
          image: "/assets/solutions/implementation_platform.png",
          highlight: true,
          isNew: true,
        },
      ],
    };
  },
};
</script>
